import { useSwipeable } from 'react-swipeable';
import { MAX_PAGE_ID, MIN_PAGE_ID } from '@/shared/constants/constants';

export const usePageSwipe = ({
  onSwiped,
  currentPageNumber,
  step = 1,
  lowerBound = MIN_PAGE_ID,
  upperBound = MAX_PAGE_ID,
}: {
  onSwiped: (page: string, direction: 'left' | 'right') => void;
  currentPageNumber: number;
  step?: number;
  lowerBound?: number;
  upperBound?: number;
}) => {
  const handlers = useSwipeable({
    onSwiped: (eventData) => {
      if (!currentPageNumber) return;

      const { dir } = eventData;

      if (dir === 'Left' && currentPageNumber - step >= lowerBound) {
        const prevPage = (currentPageNumber - step).toString();
        onSwiped(prevPage, 'left');
      }

      if (dir === 'Right' && currentPageNumber + step <= upperBound) {
        const nextPage = (currentPageNumber + step).toString();
        onSwiped(nextPage, 'right');
      }
    },
  });

  return { handlers };
};
